export const BILAN_COMPETENCES_SERVICE_ID = 1;
export const A_LA_CARTE_SERVICE_ID = 5;
export const OUTPLACEMENT_SERVICE_ID = 6;

export const DIPLOMA_OPTIONS = [
  'Aucun diplôme',
  'CAP/BEP',
  'CAP',
  'BAC',
  'BAC+1',
  'BAC+2',
  'BAC+3',
  'BAC+4',
  'BAC+5',
  'BAC+6',
  'BAC+7',
  'BAC+8',
];

export const GENDER_OPTIONS = ['Homme', 'Femme', 'Non binaire'];

export const LANGUAGE_OPTIONS = [
  { id: 1, label: 'Français' },
  { id: 2, label: 'Anglais' },
];

export const SERVICE_BADGE_COLORS: Record<number, { background: string; color: string }> = {
  1: { background: '#F8D7E8', color: '#9B1B5C' },
  2: { background: '#F8E7A0', color: '#8A6D00' },
  3: { background: '#F8D5C2', color: '#9A4B1C' },
  4: { background: '#D8F0C8', color: '#3F6B1D' },
  5: { background: '#E3D7F5', color: '#5B3A8C' },
  6: { background: '#D6E8F8', color: '#1F4E79' },
};

export const DEFAULT_BADGE_COLOR = { background: '#E8EAF0', color: '#0E1247' };

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const BENEFICIARY_ROLE_ID = 5;
export const CONSULTANT_ROLE_ID = 4;
export const MANAGER_2_ROLE_ID = 3;
export const MANAGER_3_ROLE_ID = 2;
export const DIRECTION_ROLE_ID = 1;

export const ASSIGNABLE_STAFF_ROLE_IDS = [
  CONSULTANT_ROLE_ID,
  MANAGER_2_ROLE_ID,
  MANAGER_3_ROLE_ID,
  DIRECTION_ROLE_ID,
];

export const MISSING_VALUE = 'Donnée manquante';

export const EMAIL_TAKEN_MESSAGE = 'Cette adresse email est déjà associée à un autre compte';

export const EMAIL_INVALID_MESSAGE = "Le format de l'adresse email est invalide";

export const getServiceBadgeStyle = (serviceId?: number) =>
  (serviceId && SERVICE_BADGE_COLORS[serviceId]) || DEFAULT_BADGE_COLOR;
